export default __webpack_public_path__ + "static/media/roboto-v20-latin-100.c4e674d8.eot";